import ShopablesView from "./shopables.js";
import Tracker from "./tracker.js";
import InternalTracker from "./internal-tracker.js";
import TinyGesture from 'tinygesture';

const modal = require("20220101/templates/widgets/photo-modal/index.hbs");
const modalBody = require("20220101/templates/widgets/photo-modal/modal-body.hbs");

const KEYS = {LEFT: 37, RIGHT: 39};

class PhotoModal extends HTMLElement {
  constructor() {
    super();

    this.shadow = this.attachShadow({mode: 'closed'});
    this.keyPressed = this.keyPressed.bind(this);

    this.parentWidget = this.getRootNode().host;
    this.parentWidget._modal = this;
    // get preferences directly from the outer widget.
    this.preferences = this.parentWidget.preferences;
    this.settings = this.parentWidget.settings;
    this.linkTarget = this.parentWidget.linkTarget;
    this.videoMuted = this.parentWidget.videoMuted;
    this.videoAutoplayDisabled = this.parentWidget.videoAutoplayDisabled;

    // trackers need L2H.debug, L2H.env, L2H.features.disableGoogleAnalytics
    this.trackers = [];
    let trackerOptions = {
      env: this.settings.env,
      disabled: this.settings.features.disableGoogleAnalytics
    }

    this.trackers.push(new Tracker(this.settings.clientTrackerID, `${this.settings.permalink}|${this.widgetType}`, this.settings.rootURL, this.uuid, trackerOptions))
    this.trackers.push(new InternalTracker(this.settings.permalink, this.widgetType, this.settings.appURL, this.uuid));
  }

  connectedCallback() {
    if (this.connectedCallbackCalled == true) {
      return;
    }
    this.connectedCallbackCalled = true;

    let cssTemplate = this.parentWidget.querySelector("template#css");
    this.customCSS = cssTemplate ? cssTemplate.innerHTML : "";

    this.render();
    this.appendCustomCSS();
    this.bindEvents();

    if (this.settings.modalAtBottom) {
      document.body.appendChild(this);
    }
  }

  render() {
    const context = {
      preferences: this.preferences
    };

    const renderedModal = modal(context);
    this.shadow.innerHTML = renderedModal;
  }

  bindEvents() {
    this.shadow.addEventListener("click", (e) => {
      if (e.target.closest(".l2h-close")) {
        e.preventDefault();
        this.close();
      } else if (e.target.closest(".l2h-next")) {
        e.preventDefault();
        this.next();
      } else if (e.target.closest(".l2h-previous")) {
        e.preventDefault();
        this.prev();
      } else if (e.target.closest(".trackable-link")) {
        e.preventDefault();
        let link = e.target.closest(".trackable-link")
        this.gotoURL(link.href, this.photo, link.dataset.shopableId)
      }
    });

    const el = this.shadow.querySelector(".l2h-photomodal-content")
    const gesture = new TinyGesture(el);
    gesture.on("swiperight", (event) => {
      this.prev();
    });

    gesture.on("swipeleft", (event) => {
      this.next();
    });
  }

  keyPressed(e) {
    if (!this.container.classList.contains("l2h-modal-on")) { return; };

    e.preventDefault();
    switch (e.which) {
    case KEYS.RIGHT:
      this.next();
      break;
    case KEYS.LEFT:
      this.prev();
      break;
    }
  }


  renderPhoto() {
    const context = {
      photo: this.photo,
      assetHost: this.settings.assetHost||this.settings.rootURL,
      url: this.photo.shopables.length === 1 ? this.photo.shopables[0].url : undefined,
      linkTarget: this.linkTarget,
      videoMuted: this.videoMuted,
      videoAutoplayDisabled: this.videoAutoplayDisabled,
      shareURL: `${this.settings.rootURL}p/${this.photo.share_id}`,
      aspectAsPercentage: (this.photo.height / this.photo.width) * 100,
      features: this.settings.features
    };

    this.shadow.getElementById('body-container').innerHTML = modalBody(context);

    this.renderShopables();

    for (let tracker of this.trackers) {
      tracker.trackModalView(this.photo.id);
    }
  }

  renderShopables() {
    if (!this.modalIsOpen) {
      return;
    }

    let shopablesView = new ShopablesView(this.container, {preferences: this.preferences, linkTarget: this.linkTarget});
    shopablesView.render(this.photo.shopables);
  }

  next() {
    this.emitEvent("l2h-modal-next");
  }

  prev() {
    this.emitEvent("l2h-modal-prev");
  }

  open() {
    let bodyStyle = getComputedStyle(document.body);
    const bodyPaddingTop = parseInt(bodyStyle.paddingTop);
    this.pageYOffset = window.pageYOffset;
    this.originalTop = document.body.style.top;

    this.setAttribute('photo-id', this.photo.id);
    this.container.classList.add("l2h-modal-on");
    document.body.classList.add("l2h-modal-open");
    this.modalIsOpen = true;
    this.renderShopables();
    document.addEventListener('keydown', this.keyPressed);

    this.emitEvent("l2h-modal-open");

    document.body.style.top = `-${this.pageYOffset}px`;
  }

  close() {
    this.shadow.getElementById('body-container').innerHTML = "";
    this.photo = null;
    this.container.classList.remove("l2h-modal-on");
    document.body.classList.remove("l2h-modal-open");
    this.modalIsOpen = false;
    this.setAttribute('photo-id', null);
    document.removeEventListener('keydown', this.keyPressed);

    this.emitEvent("l2h-modal-close");

    document.body.style.top = this.originalTop;
    window.scrollTo({top: this.pageYOffset, behavior: "instant"});
  }

  gotoURL(url, photo, shopableID) {
    let promises = [];
    if (photo != null) {
      for (const tracker of this.trackers) {
        promises.push(tracker.trackShopableClick(url, photo.id, shopableID));
      }
    }

    if (this.linkTarget == "_blank") {
      // if (L2H.debug) { console.log(`L2H DEBUG: about to open shoppable link ${url} in new window`); }
      return window.open(url,'_blank');
    } else {
      // if (L2H.debug) { console.log(`L2H DEBUG: about to open shoppable link ${url} in current window`); }
      return $.when.apply($, promises).done(function() {
        // if (L2H.debug) { console.log("L2H DEBUG: tracking completed"); }
        return document.location = url;
      });
    }
  }

  disablePrevBtn() {
    this.prevBtn.classList.add('l2h-disabled');
  }

  enablePrevBtn() {
    this.prevBtn.classList.remove('l2h-disabled');
  }

  disableNextBtn() {
    this.nextBtn.classList.add('l2h-disabled');
  }

  enableNextBtn() {
    this.nextBtn.classList.remove('l2h-disabled');
  }

  emitEvent(type) {
    let event = new CustomEvent(type, {});
    this.dispatchEvent(event);
  }

  appendCustomCSS() {
    if (this.customCSS.length) {
      const style = document.createElement('style');
      style.textContent = this.customCSS;
      this.shadow.appendChild(style);
    }
  }

  set photo(aPhoto) {
    this._photo = aPhoto;
    if (aPhoto) {
      this.renderPhoto();
    }
  }

  get widgetType() {
    return `${this.getAttribute("widget-type")}-widget`;
  }

  get uuid() {
    return this.getAttribute("uuid");
  }

  get photo() {
    return this._photo;
  }

  get container() {
    return this.shadow.getElementById("container");
  }

  get nextBtn() {
    return this.shadow.querySelector('.l2h-next');
  }

  get prevBtn() {
    return this.shadow.querySelector('.l2h-previous');
  }
}

customElements.define('l2h-photo-modal', PhotoModal);
